import { Cart, GetCartResponse } from '@b2b/features/cart/utilities/cart.model';
import { Product } from '@b2b/features/product/core/utilities/product.model';

export function normalizeCart(cart: GetCartResponse): Cart {
  const entries = cart.entries.map(entry => {
    const product: Product = {
      id: entry.productId,
      code: entry.productCode,
      name: entry.productName,
      imageUrls: entry.imageUrls,
      sapEAN: entry.productEan,
      sapConfigurable: false,
    };

    return {
      ...entry,
      product,
    };
  });

  return {
    ...cart,
    entries,
  };
}
